// extracted by mini-css-extract-plugin
module.exports = {"button":"EditPagePreviewButton_button__1OFfb","icon":"EditPagePreviewButton_icon__1M2-r"};